import { useEffect } from 'react';
import { getTelegram } from '../telegram';
import { WebActionBar } from '../components/WebNav';
import type { OrderCreated } from '../types';

interface Props {
  order: OrderCreated;
  onHistory: () => void;
  onContinue: () => void;
}

const fmtPrice = (n: string) =>
  Number(n).toLocaleString('ru-RU', { style: 'currency', currency: 'RUB', minimumFractionDigits: 2 });

const fmtDate = (iso: string) => {
  const d = new Date(iso);
  return d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long' });
};

export default function OrderSuccessPage({ order, onHistory, onContinue }: Props) {
  useEffect(() => {
    const tg = getTelegram();
    if (!tg) return;
    tg.BackButton.hide();
    tg.MainButton.hideProgress();
    tg.MainButton.setText('История заказов');
    tg.MainButton.show();
    tg.MainButton.onClick(onHistory);
    return () => { tg.MainButton.offClick(onHistory); tg.MainButton.hide(); };
  }, [onHistory]);

  return (
    <div className="container" style={{ padding: '48px 24px 100px', display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
      <div style={{ fontSize: 64, marginBottom: 20 }}>✓</div>
      <h3 style={{ margin: '0 0 8px', fontSize: 22, color: 'var(--tg-button)' }}>Заказ принят!</h3>
      <p style={{ margin: '0 0 24px', fontSize: 18, fontWeight: 600 }}>{order.public_number}</p>

      <div style={{
        width: '100%',
        background: 'var(--tg-secondary-bg)',
        borderRadius: 16,
        padding: '16px',
        marginBottom: 16,
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span className="hint">Дата доставки</span>
          <span style={{ fontWeight: 600 }}>{fmtDate(order.delivery_date)}</span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span className="hint">Сумма</span>
          <span style={{ fontWeight: 700, color: 'var(--tg-button)' }}>{fmtPrice(order.total_with_vat)}</span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span className="hint">Статус</span>
          <span style={{ fontWeight: 600 }}>На рассмотрении</span>
        </div>
      </div>

      {/* Блок B: заказ оплачивается с депозита — резерв сейчас, списание при отгрузке. */}
      <p className="hint" style={{ margin: '0 0 24px', fontSize: 14 }}>
        💳 Сумма заказа зарезервирована на депозите кофейни и спишется при отгрузке.
        Счёт на оплату не нужен.
      </p>

      <button
        onClick={onContinue}
        style={{
          background: 'transparent',
          border: 'none',
          color: 'var(--tg-button)',
          fontSize: 15,
          fontWeight: 600,
          fontFamily: 'inherit',
          cursor: 'pointer',
          padding: '8px 0',
        }}
      >
        Продолжить покупки
      </button>

      {/* Веб-замена Telegram MainButton «История заказов». */}
      <WebActionBar label="История заказов" onClick={onHistory} />
    </div>
  );
}
